import React, { useEffect, useState } from 'react';
import { LoadingAnimation } from 'components/ui/loading-animation';
import { useFlowThemeTransition } from './themes/FlowThemeTransition';

export interface QuestionFlowLoadingStateProps {
  /** Sit the spinner on a frosted surface so it stays legible over a flow theme backdrop. */
  frosted?: boolean;
}

export const QuestionFlowLoadingState: React.FC<QuestionFlowLoadingStateProps> = ({ frosted = false }) => {
  const { isRetainingTheme } = useFlowThemeTransition();
  const [showTransitionStatus, setShowTransitionStatus] = useState(false);
  useEffect(() => {
    if (!isRetainingTheme) {
      setShowTransitionStatus(false);
      return undefined;
    }
    const timer = window.setTimeout(() => setShowTransitionStatus(true), 350);
    return () => window.clearTimeout(timer);
  }, [isRetainingTheme]);

  return (
  <div
    className="flex min-h-screen items-center justify-center"
    data-testid="question-flow-loading-state"
  >
    {isRetainingTheme && !showTransitionStatus ? (
      <span className="sr-only" role="status">Preparing your next module…</span>
    ) : frosted || isRetainingTheme ? (
      <div
        className="flex flex-col items-center gap-2 rounded-2xl bg-white/70 p-4 shadow-[0_30px_80px_-40px_rgba(17,12,46,0.55),inset_0_1px_0_rgba(255,255,255,0.65)] backdrop-blur-xl"
        data-flow-surface="card"
        data-testid="question-flow-loading-surface"
      >
        <LoadingAnimation size="lg" />
        {isRetainingTheme ? <p role="status" className="text-sm text-slate-800">Preparing your next module…</p> : null}
      </div>
    ) : (
      <LoadingAnimation size="lg" />
    )}
  </div>
  );
};
